export default {
  development: 'development',
  local: 'local',
  production: 'production',
  prod: 'production',
  staging: 'staging',
} as Record<string, string>
